<script>
  import { derived } from 'svelte/store';
  import { getStores } from '$app/stores';
  import { browser } from '$app/environment';

  const { page } = getStores();
  const apiKey = $page.data.session.env.CHAMELEON_IO_API_KEY;
  const integrity = $page.data.session.env.CHAMELEON_IO_INTEGRITY;

  let initiated = false;
  function init() {
    // Snippet from: https://app.chameleon.io/setup/install
    window.chmln ||= {};
    if (!window.chmln.root) {
      window.chmln.accountToken = apiKey;
      window.chmln.location = window.location.href.toString();
      window.chmln.now = new Date();
      window.chmln.fastUrl = 'https://fast.chameleon.io/';

      const m = ['identify', 'alias', 'track', 'clear', 'set', 'show', 'on', 'off', 'custom', 'help', '_data'];
      for (const element of m) {
        // eslint-disable-next-line no-multi-assign
        const t = (window.chmln[`${element}_a`] = []);
        // eslint-disable-next-line func-names
        window.chmln[element] = function () {
          // eslint-disable-next-line prefer-rest-params
          t.push(arguments);
        };
      }
    }
  
    initiated = true;
  }

  const userStore = derived([page], ([s]) => s.data.session.user);
  userStore.subscribe((user) => {
    if (!user) {
      return;
    }
    if (!browser) {
      return;
    }
    if (!initiated) {
      init();
    }

    const organization = user.organizations.sort()[0];

    window.chmln.identify(user.id, {
      uid_hash: $page.data.session.env.CHAMELEON_IO_USER_ID_HASH,
      email: user.email,
      name: `${user.givenName} ${user.familyName}`,
      role: user.role,
      company: organization ? {
        uid: organization.id,
        name: organization.name,
      } : undefined,
    });
  });
</script>

<svelte:head>
  {#if browser}
    <script
      async
      src='https://fast.chameleon.io/messo/{apiKey}/messo.min.js'
      {integrity}
      crossorigin
    ></script>
  {/if}
</svelte:head>
